import { Component, OnInit, Input } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { DataService } from "../_services/data.service";
import { AlertService } from "../_services/alert.service";

@Component({
  moduleId: module.id,
  selector: "questionsanswers",
  templateUrl: "questionsanswers.component.html",
})
export class QuestionsAnswersComponent implements OnInit {
  constructor(
    private router: Router,
    private dataService: DataService,
    private activatedRoute: ActivatedRoute,
    private alertService: AlertService
  ) {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/header/questionsanswers.component.ts